import { defineStore } from 'pinia'
import requestApi from "@/api/index"
import { headers } from '@/api/requesBase'

export const useUserStore = defineStore('user', {
    state: () => {
        return {
            access: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')).access:null,
            userinfo: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')).userinfo:null,
            phoneNumber: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')).phoneNumber:null,
            encryptionPhone: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')).encryptionPhone:null,
            zoneNum: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')).zoneNum:null,
            defaultUser: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')).defaultUser:null,
            requestCode:0
        }
    },
    actions: {
        // 获取用户信息
        async getUserinfo() {
            if (this.userinfo == null && this.access != null) {
                let headers = {
                    'User-ID': this.access.userId,
                    'Access-Token': this.access.accessToken,
                    'APP-Name': 'jianpin_web_editor'
                }
                await requestApi.mainModule.getUserInfo(headers).then((res)=>{
                    const result = res.data.data;
                    const userinfo = {
                        avatar: result.avatar,
                        nickname: result.nickname,
                        user_id: result.user_id,
                        vip_expire_date: result.vip_expire_date,
                        vip_expire_time: result.vip_expire_time,
                        vip_state: result.vip_state,
                        vip_type: result.vip_type
                    }
                    this.userinfo = userinfo;
                }).catch((err)=>{
                    console.log('err',err)
                })
            }
            return this.userinfo;
        },

        // 退出登录
        loginOut(type){
            this.userinfo = null;
            this.access = null;
            this.phoneNumber = null;
            this.encryptionPhone = null;
            this.defaultUser = null;
            this.requestCode = 0;
            this.zoneNum = '+86'
            localStorage.clear();
            if(!type){
                setTimeout(() => {
                    location.reload();
                },100)
            }
        }
    },
    persist: {
        enabled: true,
        strategies: [{
            // 自定义存储的 key，默认是 store.$id
            // key: "custom storageKey",
            // 可以指定任何 extends Storage 的实例，默认是 sessionStorage
            storage: localStorage,
            // state 中的字段名，按组打包储存
            paths: ["access", "userinfo", "phoneNumber","encryptionPhone","zoneNum","defaultUser"]
        }]
    }
})